<template>
  <div class="businessList">
    <el-table
      :data="businessList"
      :stripe="false"
      @selection-change="HandleSelectionChange"
      @sort-change="HandleSortChange"
      :show-header="false"
      style="box-shadow: none"
    >
      <TableOperation
        v-if="showOperation"
        :width="80"
        :operationList="[
          {
            is_show: (row) =>
              $store.getters.checkPermission('admin_business_action.edit') &&
              row.status != -1,
            label: '移除',
            command: 'off',
          },
        ]"
        @handleOperation="HandleOperation"
      />
      <el-table-column show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="one_lines" style="text-align: left !important">
            <span
              v-if="showOperation && scope.row.status == -1"
              style="color: #999"
              >（{{l("已失效")}}）</span
            >
            <span>
              <template v-if="fromMe">{{l("我")}}</template>
              <template v-else-if="scope.row.tenant && scope.row.user">
                {{ scope.row.tenant.name }}({{ scope.row.user.mobile }})
              </template>
              <template v-else>
                <el-button
                  plain
                  type="warning"
                  size="mini"
                  style="margin-right: 15px"
                  >{{l("解锁详情")}}</el-button
                >
                {{l("匿名用户")}}
              </template>
            </span>

            <template v-if="scope.row.module == 'quotation'"> {{l("询价")}} </template>
            <template v-else-if="scope.row.module == 'purchase'">
              {{l("报价")}}
            </template>
            <template v-else-if="scope.row.module == 'raise'">
              {{l("参与拼单")}}
            </template>
            <template v-if="targetMode">
              <span
                v-if="targetMode == 1"
                class="ViewLink"
                @click="goBusiness(scope.row)"
                >{{ scope.row.info.title }}
              </span>
              <span v-else-if="targetMode == 0.5" class="color-link"
                >{{ scope.row.info.title }}
              </span>
            </template>
            ：
            <span>
              <template v-if="scope.row.module == 'purchase'">
                {{ scope.row.price }}{{l("元")}}/{{
                  scope.row.info.specification_amount[0].unit
                }}
              </template>
              <template
                v-else-if="
                  scope.row.module == 'quotation' || scope.row.module == 'raise'
                "
              >
                {{ scope.row.amount
                }}{{ scope.row.info.specification_amount[0].unit }}
              </template>
            </span>
            <span
              v-if="
                scope.row.tenant && scope.row.user && scope.row.extra_params
              "
            >
              {{ scope.row.extra_params }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="170">
        <template slot-scope="scope">
          <div style="color: #999; text-align: right !important">
            {{
              (scope.row.updated_time || scope.row.created_time).slice(0, 16)
            }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="TotalCount"
      style="margin-top: 30px; justify-content: center"
      background
      @size-change="HandleSizeChange"
      @current-change="HandleCurrentChange"
      :current-page="CurrentPage"
      :page-sizes="PageSizeList"
      :page-size="PageSize"
      layout="total, prev, pager, next, jumper"
      :total="TotalCount"
    ></el-pagination>

    <CreateOrEditSellerQuotation
      ref="CreateOrEditSellerQuotation"
      @submitDialog="GetTableList"
    />
    <CreateOrEditBuyerPurchase
      ref="CreateOrEditBuyerPurchase"
      @submitDialog="GetTableList"
    />
    <CreateOrEditAdminQuotation
      ref="CreateOrEditAdminQuotation"
      @submitDialog="GetTableList"
    />
    <CreateOrEditAdminPurchase
      ref="CreateOrEditAdminPurchase"
      @submitDialog="GetTableList"
    />
    <CreateOrEditAdminRaise
      ref="CreateOrEditAdminRaise"
      @submitDialog="GetTableList"
    />
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditSellerQuotation from "@/views/seller_quotation/operation/CreateOrEditSellerQuotation.vue";
import CreateOrEditBuyerPurchase from "@/views/buyer_purchase/operation/CreateOrEditBuyerPurchase.vue";
import CreateOrEditAdminQuotation from "@/views/admin_quotation/operation/CreateOrEditAdminQuotation.vue";
import CreateOrEditAdminPurchase from "@/views/admin_purchase/operation/CreateOrEditAdminPurchase.vue";
import CreateOrEditAdminRaise from "@/views/admin_raise/operation/CreateOrEditAdminRaise.vue";
export default {
  name: "BusinessList",
  mixins: [tableMixin],
  components: {
    CreateOrEditSellerQuotation,
    CreateOrEditBuyerPurchase,
    CreateOrEditAdminQuotation,
    CreateOrEditAdminPurchase,
    CreateOrEditAdminRaise,
  },
  props: {
    api_url: {
      type: String,
      required: true,
    },
    targetMode: {
      //0不展示 0.5展示但不跳转 1去官网 //2用户后管 3平台后管
      type: Number,
      default: 0,
    },
    fromMe: {
      type: Boolean,
      default: false,
    },
    showOperation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Sorting: "-update_time",
      businessList: [],
    };
  },
  watch: {
    api_url() {
      this.GetTableList(true);
    },
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get(this.api_url, {
          params: {
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.businessList = data.results;
        });
    },
    goBusiness(business) {
      if (this.targetMode == 1) {
        if (business.module == "quotation") {
          this.$openRouter({
            path: `/home/quotation/${business.info.code}`,
          });
        } else if (business.module == "purchase") {
          if (business.info.quality_type == 1) {
            this.$openRouter({
              path: `/home/purchase_material/${business.info.code}`,
            });
          } else if (business.info.quality_type == 3) {
            this.$openRouter({
              path: `/home/purchase_forging/${business.info.code}`,
            });
          }
        } else if (business.module == "raise") {
          this.$openRouter({
            path: `/home/raise/${business.info.code}`,
          });
        }
      }
      // else if (this.targetMode == 2) {
      //   if (business.module == "quotation") {
      //     this.$refs.CreateOrEditSellerQuotation.Type = "View";
      //     this.$refs.CreateOrEditSellerQuotation.Show(business.info);
      //   } else if (business.module == "purchase") {
      //     this.$refs.CreateOrEditBuyerPurchase.Type = "View";
      //     this.$refs.CreateOrEditBuyerPurchase.Show(business.info);
      //   }
      // } else if (this.targetMode == 3) {
      //   if (business.module == "quotation") {
      //     this.$refs.CreateOrEditAdminQuotation.Type = "View";
      //     this.$refs.CreateOrEditAdminQuotation.Show(business.info);
      //   } else if (business.module == "purchase") {
      //     this.$refs.CreateOrEditAdminPurchase.Type = "View";
      //     this.$refs.CreateOrEditAdminPurchase.Show(business.info);
      //   } else if (business.module == "raise") {
      //     this.$refs.CreateOrEditAdminRaise.Type = "View";
      //     this.$refs.CreateOrEditAdminRaise.Show(business.info);
      //   }
      // }
    },
    off(item) {
      this.$confirm(
        `${this.l("下架")}【${item.tenant.name}】?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(`/api/admin_business_action/${item.code}/off/`)
          .then(() => {
            this.GetTableList();
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
.businessList {
  font-size: 12px;
  padding: 0 20px;
  .businessItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 15px;
    .date {
      flex-shrink: 0;
      width: 120px;
      color: #999;
      text-align: right;
    }
  }
}
</style>

